<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :headers="headers"
    :options.sync="tableOptions"
    :server-items-length="totalItems"
    :items="teachings"
    loading-text="Đang Tải"
    :footer-props="footerTable"
    :loading="loading"
  >
    <template v-slot:[`item.class.title`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="'/class/' + (item.class && item.class.id)"
        v-if="$auth.policies['view-class']"
      >
        <span v-if="item.class">{{ item.class && item.class.title }}</span>
      </router-link>
      <div v-else>
        <span v-if="item.class">{{ item.class && item.class.title }}</span>
      </div>
    </template>
    <template v-slot:[`item.teacher.name`]="{ item }">
      <div class="d-flex flex-row">
        <div style="width:220px" class="mr-8">
          <CardTeacherName v-if="item.teacher" :teacher="item.teacher" link />
          <span v-else style="color: red">Chưa có giáo viên</span>
        </div>
        <div style="width:80px" v-if="item.teacher" class="align-self-center center mr-8">
          <p class="grey--text mb-0">Ngày sinh</p>
          <div v-if="item.teacher && item.teacher.dob">{{ item.teacher.dob | ddmmyyyy }}</div>
          <div v-else-if="item.teacher.metadata && item.teacher.metadata.dob">
            {{ item.teacher.metadata.dob | ddmmyyyy }}
          </div>
        </div>
        <div v-if="item.teacher" class="align-self-center center">
          <p class="grey--text mb-0">Giới tính</p>
          <div>{{ item | _get('teacher.gender') | gender }}</div>
        </div>
      </div>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <TeachingListAction :selectedTeaching="item" />
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import TeachingListAction from '@/modules/teacher/TeachingListAction.vue'

const originHeaders = [
  {
    text: 'Lớp',
    value: 'class.title',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Khối',
    value: 'grade.gradeNumber',
    align: 'left',
    sortable: false,
    show: true,
    width: 50
  },
  {
    text: 'Môn học',
    value: 'subject.title',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Giáo viên',
    value: 'teacher.name',
    align: 'left',
    sortable: true,
    show: true
  },
  // {
  //   text: '',
  //   value: 'teacher.dob',
  //   align: 'left',
  //   sortable: false,
  //   show: true
  // },
  // {
  //   text: '',
  //   value: 'teacher.gender',
  //   align: 'left',
  //   sortable: false,
  //   show: true,
  //   width: 100
  // },
  {
    text: 'Thao tác',
    align: 'center',
    value: 'action',
    sortable: false,
    show: true
  }
]

export default {
  components: {
    CardTeacherName,
    TeachingListAction
  },
  data() {
    return {
      headers: originHeaders,
      tableOptions: {}
    }
  },
  computed: {
    ...mapState('teaching', ['teachings', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('teaching', ['searchTeaching', 'searchTeachings', 'requestPageSettings']),
    refresh(query) {
      this.searchTeachings({ ...query })
    }
  },
  created() {
    this.refresh({})
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
